import { useQuery } from '@tanstack/react-query';

import inclusionsService from '~/services/cruises/InclusionsService';

import { inclusionQueryKeys } from './inclusionQueryKeys';

export function useGetInclusionFilters(inclusionId: string, enabled = true) {
  return useQuery({
    queryKey: inclusionQueryKeys.filters(inclusionId),
    queryFn: () => inclusionsService.getFilters(inclusionId),
    enabled: enabled && !!inclusionId,
  });
}
